import React, { Component } from 'react';

import WelcomeToChurchImg from '../../assets/images/new_here/FoyerCoffee.jpg';

class WelcomeToChurch extends Component {
  render() {
    return (
        <section>
          <header id="page-title">
            <div className="container">
              <h1>Welcome To Church</h1>
            </div>
          </header>
          <section className="container">
          <img src={WelcomeToChurchImg} style={{float: "right"}} alt=""/>
            <p>
              CRCK wants everything we do to be ‘all about Jesus’. We long to be more like him in every way and to help others become so too.
              So, whether you are a confirmed believer or a spiritual seeker, we hope the information you find here will help you in some way.<br /><br />

              We work hard to make it easy for people to join us at church. We want you to feel welcome. But we also want our welcome to extend beyond mere friendliness.
              We want you to be able to get involved with us and take your place in the spiritual life and service of our church.<br /><br />

              We are well aware that settling into a church can be daunting, even frustrating at times, and therefore something we could easily put off.
              But because being part of a local church is crucial to making life ‘all about Jesus’, we want to do whatever we can to help you take the plunge and join us!
            </p>

          </section>
        </section>
    );
  }
}

export default WelcomeToChurch;
